// @ts-ignore
import { Select } from '@amzn/awsui-components-react';
import React, { useContext } from 'react';
import { AppContext } from '../../../utils/appContext';
import { getTumblerConfig } from '../../../utils/appConfig';
import './../../../Styles/navbar.css';

const STAGE_LABELS: { [key: string]: string } = {
  prod: 'Prod',
  gamma: 'Integ',
  beta: 'Staging',
};

/** Build grouped region options from CDK-injected stageRegions config. */
function buildGroupedOptions() {
  const config = getTumblerConfig();
  const stageRegions = config.stageRegions;

  // Fallback: if completely empty, show at least current region
  const hasAnyRegions = Object.values(stageRegions).some(r => r.length > 0);
  if (!hasAnyRegions) {
    return [{
      label: STAGE_LABELS[config.stage] || config.stage,
      value: config.stage,
      options: [{ label: `${config.current.airportCode.toUpperCase()} (${config.current.publicRegion})`, value: `${config.current.airportCode.toLowerCase()}-${config.stage}` }],
    }];
  }

  const stageOrder = ['gamma', 'beta', 'prod'];
  const stages = Object.keys(stageRegions).sort((a, b) => {
    const ai = stageOrder.indexOf(a);
    const bi = stageOrder.indexOf(b);
    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
  });

  return stages.map(stage => ({
    label: STAGE_LABELS[stage] || stage,
    value: stage,
    options: stageRegions[stage]
      .map(r => ({
        label: `${r.airportCode.toUpperCase()} (${r.publicRegion})`,
        value: `${r.airportCode.toLowerCase()}-${stage}`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  }));
}

const groupedOptions = buildGroupedOptions();
export const tumblerBetaRegions = groupedOptions.find(g => g.value === 'beta')?.options || [];
export const tumblerGammaRegions = groupedOptions.find(g => g.value === 'gamma')?.options || [];
export const tumblerProdRegions = groupedOptions.find(g => g.value === 'prod')?.options || [];

export const RegionSwitcher = () => {
  const appContext = useContext(AppContext);
  const config = getTumblerConfig();
  const currentAirport = config.current.airportCode.toLowerCase();
  const currentStage = config.stage;

  // Find current selection in grouped options
  const currentValue = `${currentAirport}-${currentStage}`;
  let defaultRegion: { label: string; value: string } | undefined;
  for (const group of groupedOptions) {
    const found = group.options.find(r => r.value === currentValue);
    if (found) { defaultRegion = found; break; }
  }
  if (!defaultRegion) {
    defaultRegion = {
      label: `${currentAirport.toUpperCase()} (${config.current.publicRegion})`,
      value: currentValue,
    };
  }

  const [selectedOption, setSelectedOption] = React.useState(defaultRegion);

  const handleChange = (event) => {
    const [region, stage] = event.detail.selectedOption.value.split('-');
    setSelectedOption(event.detail.selectedOption);
    // Derive domain suffix from current host (handles ADC domains like tumbler.oss.aws.c2s-a2z.ic.gov)
    const hostParts = window.location.host.split('.');
    const domainSuffix = hostParts.slice(2).join('.');
    const path = window.location.href.indexOf('lse-tool') > -1 ? '/lse-tool' : '';
    window.location.assign(`https://${region}.${stage}.${domainSuffix}${path}`);
  };
  return (
    <Select
      className="dropdown-nav"
      selectedOption={selectedOption}
      onChange={handleChange}
      options={groupedOptions}
      ariaRequired
      selectedAriaLabel="Selected"
    />
  );
};
